import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';

@Component({
    selector: 'error',
    styleUrls: ['./error.component.scss'],
    templateUrl: './error.component.html',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'error-page app'
    },
    imports: [
      CommonModule,
      MatButtonModule,
      MatIconModule
    ]
})
export class ErrorComponent {
  router: Router;
  currentDate

  constructor(router: Router) {
    this.router = router;
    this.currentDate = new Date()
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}
